// extracted by mini-css-extract-plugin
export default {"light":"Icon_light__AEyUx","dark":"Icon_dark__sRUQ9"};